const u = (f, t, m, e) => {
  const d = {
    offerId: void 0,
    productId: void 0,
    paymentMethod: void 0,
    availablePaymentMethods: [],
    currency: void 0,
    pricePlan: void 0,
    finalAmount: void 0,
    contactFields: {}
  }, c = (a) => f((l) => ({ ...l, offer: { ...l.offer, ...a } }));
  return {
    offerId: (e == null ? void 0 : e.offerId) ?? d.offerId,
    setOfferId: (a) => c({ offerId: a }),
    productId: (e == null ? void 0 : e.productId) ?? d.productId,
    setProductId: (a) => c({ productId: a }),
    paymentMethod: (e == null ? void 0 : e.paymentMethod) ?? d.paymentMethod,
    setPaymentMethod: (a) => c({ paymentMethod: a }),
    availablePaymentMethods: (e == null ? void 0 : e.availablePaymentMethods) ?? d.availablePaymentMethods,
    setAvailablePaymentMethods: (a) => c({ availablePaymentMethods: a }),
    currency: (e == null ? void 0 : e.currency) ?? d.currency,
    setCurrency: (a) => c({ currency: a }),
    pricePlan: (e == null ? void 0 : e.pricePlan) ?? d.pricePlan,
    setPricePlan: (a) => c({ pricePlan: a }),
    finalAmount: (e == null ? void 0 : e.finalAmount) ?? d.finalAmount,
    setFinalAmount: (a) => c({ finalAmount: a }),
    contactFields: (e == null ? void 0 : e.contactFields) ?? d.contactFields,
    setContactFields: (a) => c({ contactFields: a })
  };
};
export {
  u as createOfferSlice
};
